  $(document).on('turbolinks:load', function () {
  // プレビュー機能
  var preview = document.getElementById('markdown-preview');
  var previewContent = document.getElementById('markdown-preview-content');
  
  if(preview && previewContent) {
    document.querySelectorAll('[data-markdown-preview-target]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var textarea = document.getElementById(btn.dataset.markdownPreviewTarget);
        if(!textarea) return;
        fetch('/api/markdown_preview', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
          },
          body: JSON.stringify({ text: textarea.value })
        })
        .then(response => response.json())
        .then(data => {
          previewContent.innerHTML = data.html;
          preview.classList.remove('hidden');
        });
      });
    });
  }

  // マークダウンヘルプの開閉
  var helpToggle = document.getElementById('markdown-help-toggle');
  var helpPanel = document.getElementById('markdown-help');
  var helpIcon = document.getElementById('markdown-help-icon');
  if(helpToggle && helpPanel) {
    helpToggle.addEventListener('click', function() {
      helpPanel.classList.toggle('hidden');
      if(helpIcon) {
        helpIcon.setAttribute('data-lucide', helpPanel.classList.contains('hidden') ? 'chevron-down' : 'chevron-up');
        if(window.lucide) { window.lucide.createIcons(); }
      }
    });
  }

  // 使用例のコピーボタン
  document.querySelectorAll('.markdown-help-copy-btn').forEach(function(copyBtn) {
    copyBtn.addEventListener('click', function() {
      var targetId = this.dataset.copyTarget;
      var target = document.getElementById(targetId);
      if(!target) return;

      navigator.clipboard.writeText(target.textContent.trim()).then(function() {
        var icon = copyBtn.querySelector('i');
        if(icon) {
          icon.setAttribute('data-lucide', 'check');
          if(window.lucide) { window.lucide.createIcons(); }
          setTimeout(function() {
            icon.setAttribute('data-lucide', 'copy');
            if(window.lucide) { window.lucide.createIcons(); }
          }, 1500);
        }
      });
    });
  });
});
